import { createFetchListAction, createFetchOneAction, createCreateOneAction, createUpdateOneAction, createPatchOneAction, createDeleteOneAction, createInvalidateAction, createPostAction, createPutAction, createPatchAction, createHeadAction } from './actions';
import { selectIsLoadedResource, selectIsFetchingResource, selectIsFetchingOneResource, selectIsLoadedOneResource, selectIsCreatingOneResource, selectIsDeletingOneResource, selectIsUpdatingOneResource, selectIsPatchingOneResource, selectIsToRefetchResource, selectIsToRefetchOneResource, selectIsFailureResource, selectIsFailureOneResource, selectIsHeadingResource, selectIsHeadFailureResource, selectIsPostingResource, selectIsPuttingResource, selectIsPatchingResource, selectShouldFetch, selectShouldFetchOne } from './reducer';
var wrapSelectorForResource = function wrapSelectorForResource(resource, selector) {
  return function (state, options) {
    var label;
    var status;

    // undefined below, fixes selection when no label is passed
    // to fallback on the default label
    // ie: selectIsFailure(state)
    // === selectIsFailure(state, 'default')
    // === selectIsFailure(state, {})
    // === selectIsFailure(state, { label: 'default' })
    // === selectIsFailure(state, { label: 'default', status: 123 })
    // === selectIsFailure(state, { status: 123 })

    if (options && typeof options === 'string') {
      label = options;
    } else {
      if (options && 'label' in options) {
        label = options.label;
      }
      if (options && 'status' in options) {
        status = options.status;
      }
    }
    return selector(state, {
      resource: resource,
      label: label,
      status: status
    });
  };
};

/**
 * Create a new resource Object.
 */
export default (function (name, options) {
  return {
    name: name,
    options: options,
    fetch: createFetchListAction(name),
    fetchOne: createFetchOneAction(name),
    createOne: createCreateOneAction(name),
    updateOne: createUpdateOneAction(name),
    patchOne: createPatchOneAction(name),
    deleteOne: createDeleteOneAction(name),
    invalidate: createInvalidateAction(name),
    head: createHeadAction(name),
    post: createPostAction(name),
    put: createPutAction(name),
    patch: createPatchAction(name),
    selectIsLoaded: wrapSelectorForResource(name, selectIsLoadedResource),
    selectIsFailure: wrapSelectorForResource(name, selectIsFailureResource),
    selectIsFetching: wrapSelectorForResource(name, selectIsFetchingResource),
    selectIsToRefetch: wrapSelectorForResource(name, selectIsToRefetchResource),
    selectIsLoadedOne: wrapSelectorForResource(name, selectIsLoadedOneResource),
    selectIsFetchingOne: wrapSelectorForResource(name, selectIsFetchingOneResource),
    selectIsFailureOne: wrapSelectorForResource(name, selectIsFailureOneResource),
    selectIsToRefetchOne: wrapSelectorForResource(name, selectIsToRefetchOneResource),
    selectIsCreatingOne: wrapSelectorForResource(name, selectIsCreatingOneResource),
    selectIsDeletingOne: wrapSelectorForResource(name, selectIsDeletingOneResource),
    selectIsUpdatingOne: wrapSelectorForResource(name, selectIsUpdatingOneResource),
    selectIsPatchingOne: wrapSelectorForResource(name, selectIsPatchingOneResource),
    selectIsPosting: wrapSelectorForResource(name, selectIsPostingResource),
    selectIsPutting: wrapSelectorForResource(name, selectIsPuttingResource),
    selectIsPatching: wrapSelectorForResource(name, selectIsPatchingResource),
    selectIsHeading: wrapSelectorForResource(name, selectIsHeadingResource),
    selectIsHeadFailure: wrapSelectorForResource(name, selectIsHeadFailureResource),
    selectShouldFetch: wrapSelectorForResource(name, selectShouldFetch),
    selectShouldFetchOne: wrapSelectorForResource(name, selectShouldFetchOne)
  };
});